module.exports = __webpack_public_path__ + "static/media/send.9ab8d9ac.svg";